import React, { useState, useMemo, useEffect } from 'react';
import { Grid, Tooltip, CircularProgress } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import EditIcon from '@material-ui/icons/Edit';
import ReactDOM from 'react-dom';
import BreadCrumbs from '../../../Core/Controls/Breadcrumb';
import ReportGijgoGrid from '../../internal/ReportsScreens/GijgoForReportsScreen';
import { SquareButton } from '../../../Core/FormInput/AppButton';
import DialogComp from '../../../Core/Modal/dialogModal';
import AddEditCustomer from './addEditCustomer';
import { GetTCards_GetCustomers } from '../../../Core/Service/T-card-services';
import NotesIcon from '@material-ui/icons/Notes';
import NotificationsIcon from '@material-ui/icons/Notifications';
import CustomerNotesModal from './customerNotesModal';
import DescriptionIcon from '@material-ui/icons/Description';

let styleObj = {
    backgroundColor: '#183B68',
    borderRadius: '20%',
    width: '32px',
    height: '32px',
    textAlign: 'center',
    padding: '0px 0px 0px 0px'
};

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'T-Card', active: true },
    { name: 'Customers', path: '/', active: true }
];

const CustomersListScreen = () => {
    const [state, setState] = useState({
        isReload: new Date(),
        showModal: false,
        selectedCustomerID: null,
        selectedCustomer: null,
        rows: [],
        showCustNotesModal: false,
        loading: true // Added loading state
    });

    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                const res = await GetTCards_GetCustomers();
                setState((st) => ({
                    ...st,
                    rows: res?.data.customer || [],
                    loading: false
                }));
            } catch (err) {
                console.error('Error loading customers', err);
                setState((st) => ({
                    ...st,
                    loading: false
                }));
            }
        };

        fetchCustomers();
    }, []);

    const handleClose = (shouldReload) => {
        setState((st) => ({
            ...st,
            showModal: false,
            showCustNotesModal: false,
            isReload: shouldReload ? new Date() : st.isReload
        }));
    };

    const baseColumns = [
        {
            field: 'action',
            title: `Action`,
            filterable: false,
            sortable: false,
            width: '3%'
        },
        {
            field: 'ac',
            title: `Account Code`,
            filterable: true,
            sortable: true,
            width: '10%'
        },
        {
            field: 'c',
            title: `Customer`,
            filterable: true,
            sortable: true,
            width: '10%'
        },
        {
            field: 'a',
            title: `Address`,
            filterable: true,
            sortable: true,
            width: '10%'
        },
        {
            field: 'e',
            title: `Email`,
            filterable: true,
            sortable: true,
            width: '10%'
        },
        {
            field: 'p',
            title: `Phone`,
            filterable: true,
            sortable: true,
            width: '10%'
        }
    ];

    const handelAddUpdate = (row = null) => {
        setState((st) => ({
            ...st,
            showModal: true,
            selectedCustomerID: row ? row.cid : null,
            selectedCustomer: row || null
        }));
    };

    const handelCustomerNotes = (row = null) => {
        setState((st) => ({
            ...st,
            showCustNotesModal: true,
            selectedCustomerID: row ? row.cid : null,
            selectedCustomer: row || null
        }));
    };

    const editButton = () => (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="space-evenly">
                <Tooltip title="Edit Customer Notifications" arrow>
                    <abbr style={{ textDecoration: 'none' }}>
                        <SquareButton style={styleObj} onClick={() => handelAddUpdate(record)}>
                            <NotificationsIcon fontSize="small" style={{ color: 'white' }} />
                        </SquareButton>
                    </abbr>
                </Tooltip>
                <Tooltip title="Customer Notes" arrow>
                    <abbr style={{ textDecoration: 'none' }}>
                        <SquareButton style={styleObj} onClick={() => handelCustomerNotes(record)}>
                            <DescriptionIcon fontSize="small" style={{ color: 'white' }} />
                        </SquareButton>
                    </abbr>
                </Tooltip>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];
        let actionCol = tempCols.find((element) => element.field === 'action');

        if (actionCol) {
            actionCol.renderer = editButton({});
        }

        return tempCols;
    }, []);

    const renderTitle = () => {
        return (
            <Grid container justifyContent="space-between">
                <Grid item xs={12} sm={3}>
                    <Grid container>
                        <Grid item xs={12} style={{ fontSize: 14 }}>{`Customer`}</Grid>
                        <Grid item style={{ fontSize: 14, fontWeight: 'bold' }}>{`${state.selectedCustomer?.c || ''}`}</Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Grid container>
                        <Grid item xs={12} style={{ fontSize: 14 }}>{`Email`}</Grid>
                        <Grid item xs style={{ fontSize: 14, fontWeight: 'bold' }}>{`${state.selectedCustomer?.e || ''}`}</Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Grid container>
                        <Grid item xs={12} style={{ fontSize: 14 }}>{`Phone`}</Grid>
                        <Grid item xs style={{ fontSize: 14, fontWeight: 'bold' }}>{`${state.selectedCustomer?.p || ''}`}</Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    return (
        <div>
            <BreadCrumbs crumbs={crumbs} />
            <Grid container>
                <Grid item xs={12}>
                    {state.loading ? (
                        <Grid container justifyContent="center" alignItems="center" style={{ height: '200px' }}>
                            <CircularProgress />
                        </Grid>
                    ) : (
                        <ReportGijgoGrid columns={columns} isReload={state.isReload} localRowsData={state.rows} />
                    )}
                </Grid>
            </Grid>

            {state.showModal ? (
                <DialogComp overflow="auto" title={renderTitle()} onClose={() => handleClose(false)} maxWidth="lg" fullWidth={true}>
                    <AddEditCustomer selectedCustomerID={state.selectedCustomerID} selectedCustomer={state.selectedCustomer} onClose={handleClose} />
                </DialogComp>
            ) : null}

            {state.showCustNotesModal ? (
                <CustomerNotesModal selectedCustomer={state.selectedCustomer} selectedCustomerID={state.selectedCustomerID} onClose={handleClose} />
            ) : null}
        </div>
    );
};

export default CustomersListScreen;
